var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprintIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "var(--default-color-font)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M907 1793 l-97 -98 100 -100 100 -100 0 39 0 39 38 -6 c20 -4 75 -25 121 -48 141 -70 243 -189 297 -349 26 -77 26 -263 0 -340 -50 -149 -154 -275 -282 -342 -135 -71 -133 -71 -683 -76 l-494 -4 52 -52 51 -52 -50 -49 c-27 -27 -50 -53 -50 -57 0 -12 892 -10 990 3 311 38 571 251 670 546 28 83 33 117 37 218 4 85 0 141 -10 191 -68 319 -317 569 -629 633 l-57 12 -3 45 -3 45 -98 -98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 1779 c-221 -57 -417 -219 -516 -424 -56 -116 -74 -185 -82 -315 -9 -167 32 -328 123 -473 l36 -57 156 0 156 0 -61 58 c-77 74 -134 161 -164 254 -33 101 -33 263 0 358 66 188 222 337 406 385 32 8 59 16 61 18 2 2 -21 28 -51 57 l-55 54 52 53 c60 61 56 63 -61 32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 457 l0 -47 -101 0 -102 0 -67 -63 c-37 -35 -98 -84 -135 -108 l-68 -44 236 -3 236 -2 3 -40 3 -41 98 98 97 98 -100 100 -100 100 0 -48z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprintIcon);
export default __webpack_public_path__ + "static/media/sprint-icon.00758aae.svg";
export { ForwardRef as ReactComponent };